import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-divider',
  templateUrl: './demo-divider.component.html',
  styleUrls: ['./demo-divider.component.less']
})
export class DemoDividerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
